module.exports = __webpack_public_path__ + "img/P150T_weapon_129.7ae7369d.png";